import { actionsFromList } from '@mgc/map-client-shared/lib/ReduxTools';
import { startIdleMonitor } from '@mgc/map-client-shared/lib/IdleMonitor';
import cookie from 'cookie';
import LoginActions from './login';
import UserActions from './user';
import OfferActions from './offer';
import UiActions from './ui';
import ErrorActions from './error';
import CartActions from './cart';

export default class BootstrapActions {
    static types = actionsFromList(['APP_MOUNTED']);

    // sync --------------------------------------------------------------------

    static appMounted = () => ({ type: BootstrapActions.types.APP_MOUNTED });

    // async -------------------------------------------------------------------

    static bootstrapApp = () => (dispatch, getState) => {
        const cookies = cookie.parse(document.cookie);

        if (!cookies.xsrf_token) {
            dispatch(LoginActions.wantLogin(true));
            return;
        }

        dispatch(LoginActions.storeXsrfToken(cookies.xsrf_token));
        dispatch(startIdleMonitor());

        Promise.all([getState().api.getMyUser(), getState().api.getMyOffers()])
            .then(([user, offers]) => {
                dispatch(UserActions.receivedUser(user));
                dispatch(OfferActions.receivedOffers(offers));
            })
            .then(() => {
                dispatch(BootstrapActions.appMounted()); // Ensure this dispatch happens first
                dispatch(CartActions.setItems()); // Dispatch with user and selectedOffer
                if (!getState().myself.preferences.joyrideStatus) {
                    dispatch(UiActions.openModal('newUser'));
                }
            })
            .catch(ErrorActions.errorHandler(dispatch));
    };
}



// WEBPACK FOOTER //
// ./app/actions/bootstrap.js